import PageContainer from '@/views/base/page.vue'
export default [
  {
    path: '/index',
    component: PageContainer,
    children: [
      {
        path: '/model',
        component: () => import('@/views/model/index.vue'),
        meta: { title: '模型', keepAlive: false, needAuth: false }
      }
    ]
  }
]
